var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper thumbnail"},[_c('img',{style:({ display: 'block', margin: '1.5rem auto' }),attrs:{"src":_vm.src,"alt":"example product image","width":"80px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }